import { tWithKeyAttr as t } from "../../i18nHelper";
import progressLineStyle from "./progressLine.module.css";

interface ProgressBarProps {
    answeredCount: number;
    totalQuestions: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ answeredCount, totalQuestions }) => {
    const progress = totalQuestions === 0 ? 0 : Math.round((answeredCount / totalQuestions) * 100);

    return (
        <div className={progressLineStyle.progressHeader}>
            <p>{t('HATKADMUT')} {progress}% ({answeredCount} {t('MITUCH')} {totalQuestions})</p>
            <progress value={answeredCount} max={totalQuestions} />
        </div>
    );
};

export default ProgressBar;
